// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MetadataInput
 */
export interface MetadataInput {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof MetadataInput
   */
  annotations?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof MetadataInput
   */
  labels?: { [key: string]: string };
}

/**
 * Check if a given object implements the MetadataInput interface.
 */
export function instanceOfMetadataInput(value: object): value is MetadataInput {
  return true;
}

export function MetadataInputFromJSON(json: any): MetadataInput {
  return MetadataInputFromJSONTyped(json, false);
}

export function MetadataInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MetadataInput {
  if (json == null) {
    return json;
  }
  return {
    annotations: json['annotations'] == null ? undefined : json['annotations'],
    labels: json['labels'] == null ? undefined : json['labels'],
  };
}

export function MetadataInputToJSON(json: any): MetadataInput {
  return MetadataInputToJSONTyped(json, false);
}

export function MetadataInputToJSONTyped(
  value?: MetadataInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    annotations: value['annotations'],
    labels: value['labels'],
  };
}
